import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { store } from '@/stores'

import type { ILayoutOptions } from '@/types/layout'

export const useLayoutStore = defineStore('layout', () => {
  // 状态栏高度
  const statusBarHeight = ref(0)
  // 设备像素比
  const deviceRatio = ref(window.devicePixelRatio || 1)

  // 计算实际的状态栏高度
  const actualStatusBarHeight = computed(() => statusBarHeight.value / deviceRatio.value)

  // 设置状态栏高度
  const setStatusBarHeight = (height: number) => {
    statusBarHeight.value = height
  }

  // 从layoutOptions初始化状态栏高度
  const initStatusBarHeight = (layoutOptions?: ILayoutOptions) => {
    if (layoutOptions?.statusBar?.height) {
      setStatusBarHeight(layoutOptions.statusBar.height)
    }
  }

  // 设置设备像素比
  const setDeviceRatio = (ratio: number) => {
    deviceRatio.value = ratio
  }

  return {
    // state
    statusBarHeight,
    deviceRatio,
    // getters
    actualStatusBarHeight,
    // actions
    setStatusBarHeight,
    initStatusBarHeight,
    setDeviceRatio
  }
})

export function useLayoutStoreHook() {
  return useLayoutStore(store)
}
